module.exports = __webpack_public_path__ + "5171ab3c3ab281cf8aa52efd7f13b20e.fbx";